<template>
    <a-modal v-model="visible" :title="'编辑'+title+'类目'" on-ok="handleOk">
        <template slot="footer">
            <a-button key="submit" type="primary" :loading="loading" @click=" handleOk">
            确定
            </a-button>
            <a-button key="back"   @click="handleCancel">
            取消
            </a-button>
        </template>
        <div class="item" style="margin-bottom:20px;" v-show="title=='二级'">
          <label class="ant-col-5" style="text-align: right;color: rgba(0, 0, 0, 0.85);">一级类目：</label>{{category.parentCategoryName}}
        </div>
        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
            <a-form-item :label="title+'类目名'">
                <a-input
                    v-decorator="['categoryName', { rules: [{ required: true, message: '请输入类目名称!' }] }]"
                />
            </a-form-item>
        </a-form>

    </a-modal>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      visible: false,
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      category:{},
    };
  },
  props:{
    title:{
      type:String,
      default:'二级'
    }
  },
  methods: {
    showModal(params) {
      this.category ={... params};
      this.visible = true;
      this.$nextTick(()=>{
        this.form.setFieldsValue({categoryName:params.categoryName})
      })
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
          let params = {...values};
          params.id = this.category.id;
          this.loading = true;
          let url = this.title=='二级'?'secondaryCategory/modifyRecord':'primaryCategory/modifyRecord'
          this.$http.post(url,params).then(res=>{
            if (res.result) {
              this.handleCancel();
              this.$message.success('更新成功');
            } else {
              this.$message.warning(res.message);
            }
            
          })
          this.loading = false;
        }
      });
    },
    handleCancel(e) {
      this.visible = false;
      this.form.resetFields();
      this.$emit("getdata");
    },
  },
};
</script>
